

export default (permission) => {
  let user = JSON.parse(localStorage.getItem("cws_user"))
  if(user.role.permission[permission]){
    return true
  }
  return false
}